import { LoadState } from "../../constants/enums";
import { ITaskListItem, ITaskListState } from "./taskList.types";

export const initialTaksListItem: ITaskListItem = {
  task_uuid: "",
  type: "project",
  type_name: "",
  type_uuid: "",
  project_manager_uuid: null,
  project_manager: null,
  title: "",
  description: null,
  due_date: null,
  upload_file: [],
  priority: "HIGH",
  category_name: null,
  category_uuid: null,
  assignee: [],
  time_taken: null,
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  estimated_time: "",
  expected_time: "",
  schedule_date: null,
  schedule_status: "",
  status: "TODO",
};

export const initialTaskListState: ITaskListState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  TaskListItem: initialTaksListItem,
  TaskListLoading: LoadState.NotLoaded,
  error: null,
  subTaskList: [],
  subTaskListLoading: LoadState.NotLoaded,
  subTaskListTotalRecords: 0,
};
